import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

import { CleverTapHeaderHelp } from 'aurora-utils/cleverTap.eventhelper';
import { FRESH_DESK_URL } from 'aurora-utils/constants';
import ADGMImage from '../ADGMImage';
import styles from './styles';

const { HELP_URL } = FRESH_DESK_URL;

function NoData(props) {
  const { classes } = props;

  const helpHandler = () => {
    CleverTapHeaderHelp();
    window.open(`${HELP_URL}/${localStorage.getItem('lang')}/support/home`, '_blank');
  };

  return (
    <div className={classes.transactionsNotification}>
      <figure>
        <ADGMImage name='not-found.png' width='125' alt='Not found' />
      </figure>
      <div className={classes.tcTextHolder}>
        <Typography variant='body1' component='h1' className={classes.title}>
          <FormattedMessage {...messages.nothing_found} />
        </Typography>
        <Typography variant='body1'>
          <FormattedMessage
            {...messages.nothing_found_helperText}
            values={{
              s: (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                <span className={classes.supportLink} onClick={helpHandler}>
                  <FormattedMessage {...messages.dari_support} />
                </span>
              ),
            }}
          />
        </Typography>
      </div>
    </div>
  );
}

NoData.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NoData);
